import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";

const reshapeForm = (form) => {
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('code', form.code);
    formData.append('HowManyCanBeUsed', form.HowManyCanBeUsed);
    formData.append('price', form.price);
    formData.append('active_at', form.active_at);
    formData.append('expire_at', form.expire_at);
    formData.append('offerable_id', form.offerable_id);
    formData.append('offerable_type', form.offerable_type);
    return formData
}

export default {
    namespaced: true,
    state: {
        offers: [],
        trash: [],
        offer: {},
        links: {},
        meta: {},
    },
    mutations: {
        setOffers(state, offers) {
            state.offers = offers;
        },
        setTrash(state, trash) {
            state.trash = trash;
        },
        setOffer(state, offer) {
            state.offer = offer;            
        },
        setLinks(state, links) {
            state.links = links;
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        removeOffer: (state, offer) => {            
            state.offers.splice(findObjectIndex(state.offers, offer), 1)
            state.trash.splice(findObjectIndex(state.trash, offer), 1)
        },
    },
    actions: {
        getOffers({commit}, page=1) {
            axios.get(`offer`)
                .then(res => { 
                    res = res.data.data;

                    commit('setOffers', res.data);
                    commit('setLinks', res.links);
                    commit('setMeta', res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        getTrash({commit}, page=1) {
            axios.post(`offer/trash?page=${page}`)
                .then(res => {
                    res = res.data.data;

                    commit('setTrash', res.data);
                    commit('setLinks', res.links);
                    commit('setMeta', res.meta);
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                })
        },
        async getOffer({commit}, id) {
            await axios.get(`offer/${id}`)
                .then(res => {
                    res = res.data.data
                    commit('setOffer', res);
                    return res.data;
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error);
                    return undefined;
                })
        },
        deleteOffer({commit}, offer) {
            axios.delete(`offer/${offer.id}`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('تخفیف با موفقیت حذف شد ', 'تخفیف با موفقیت حذف شد ')
                    commit('removeOffer', offer)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        forceDeleteOffer({commit}, offer) {
            axios.delete(`offer/${offer.id}/force-delete`)
                .then(res => {
                    const deleted = res.data.data;

                    toast('تخفیف با موفقیت حذف شد ', 'تخفیف با موفقیت حذف شد ')
                    commit('removeOffer', offer)
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        restoreOffer({commit}, offer) {
            axios.put(`offer/${offer.id}/restore`)
                .then(res => {
                    const deleted = res.data.data;
                    
                    commit('removeOffer', offer)
                    toast('تخفیف با موفقیت بازیابی شد ', 'تخفیف با موفقیت بازیابی شد ')                  
                })
                .catch(error => {
                    toast(error.response.data.message);
                    console.log(error)
                });
        },
        createOffer({commit}, form) {
            const formData = reshapeForm(form);
            axios.post(`/offer`, formData)
                .then(res => {
                    const offer = res.data.data;
                    const offers = {
                        ...store.getters['Offer/getOffers'],
                        offer
                    }

                    toast('ایجاد تخفیف با موفقیت انجام شد', 'ایجاد تخفیف با موفقیت انجام شد')
                    commit('setOffers', offers)
                    router.push({name: "Offer"})
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
        },
        updateOffer({commit}, form) {
            const formData = reshapeForm(form);
            formData.append('_method', 'PUT');

            axios.post(`/offer/${form.id}`, formData)
                .then(res => {
                    const offer = res.data.data;
                    const offers = {
                        ...store.getters['Offer/getOffers'],
                        offer
                    }

                    toast('عملیات با موفقیت انجام شد', 'به روز رسانی تخفیف با موفقیت انجام شد')
                    commit('setOffers', offers)
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
        },
        

        
    },
    getters: {
        getOffers: state => state.offers,
        getTrash: state => state.trash,
        getOffer: state => state.offer,
        getPaginationLinks: state => state.links,
        getPaginationMeta: state => state.meta,
    }
}